/* eslint-disable react/prop-types */
import React from "react";

export const GoogleLogo = ({ onClick, className }) => {
	return (
		<svg
			className={className}
			onClick={onClick}
			width="50"
			height="50"
			viewBox="0 0 50 50"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_9647_635)">
				<path
					d="M50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50C38.8071 50 50 38.8071 50 25Z"
					fill="white"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M36.52 25.2714C36.52 24.4485 36.4464 23.6272 36.3 22.8174H25V27.4594H31.458C31.3244 28.1937 31.0433 28.8932 30.6316 29.5158C30.22 30.1383 29.6863 30.6709 29.063 31.0814V34.0924H32.941C34.1221 32.955 35.051 31.5821 35.6674 30.0627C36.2838 28.5432 36.5739 26.9112 36.519 25.2724L36.52 25.2714Z"
					fill="#4285F4"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M25 36.9993C27.9212 37.0787 30.7623 36.0387 32.942 34.0923L29.064 31.0813C28.1363 31.6767 27.0849 32.0524 25.99 32.1798C24.8951 32.3072 23.7855 32.1829 22.7459 31.8163C21.7064 31.4498 20.7642 30.8507 19.9913 30.0648C19.2184 29.2789 18.6351 28.3268 18.286 27.2812H14.276V30.3903C15.2753 32.3776 16.8074 34.048 18.7011 35.2151C20.5948 36.3821 22.7756 36.9998 25 36.9993Z"
					fill="#34A853"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M18.285 27.2784C17.7832 25.7998 17.7832 24.197 18.285 22.7184V19.6094H14.276C13.4367 21.2818 12.9997 23.1272 12.9997 24.9984C12.9997 26.8696 13.4367 28.7149 14.276 30.3874L18.285 27.2784Z"
					fill="#FBBC05"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M25 17.7718C26.7056 17.7434 28.3537 18.3883 29.587 19.5668L33.029 16.1238C30.8569 14.0841 27.9795 12.9642 25 12.9988C22.7754 12.9984 20.5944 13.6165 18.7007 14.7839C16.807 15.9513 15.275 17.6221 14.276 19.6098L18.285 22.7188C18.7462 21.2955 19.6421 20.0526 20.8467 19.1652C22.0513 18.2777 23.5039 17.7904 25 17.7718Z"
					fill="#EA4335"
				/>
			</g>
			<defs>
				<clipPath id="clip0_9647_635">
					<rect width="50" height="50" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};
